export default __webpack_public_path__ + "static/media/sequrncing.74c83d16.gif";